import React, { Fragment } from "react";
import { NavLink } from "react-router-dom";
import Form from "react-bootstrap/lib/Form";
import SVG from "react-inlinesvg";
import { RouteUrls } from "../../../configs/routeUrls";
import { ImageMimeType } from "../../../utils/enums";
import { transformSVG } from "../../../utils/svg-extensions";
import map from "lodash.map";

export const ProjectResult = ({ index, categoryName, projects }) => {
  return (
    <Fragment>
      <div className="consultation-item consultation-item-no-shadow consultation-item-no-border">
        <div className="consultation-item__header text text--font-size-25 text--weight-700 text--bottom-20">
          Miejsce {index + 1}
        </div>
        {map(
          projects,
          ({
            projectTaskId,
            projectTaskPoints,
            projectTaskName,
            projectTaskThumbMainImage,
            projectTaskThumbMainImageContentType,
            projectTaskCost,
            projectTaskDescription,
          }) => {
            const substringDescription = projectTaskDescription
              ? projectTaskDescription.substring(0, 270)
              : "";

            return (
              <Fragment key={projectTaskId}>
                <div className="consultation-item__header">
                  {projectTaskName}
                </div>
                <div
                  className={`consultation-item__body consultation-item__body--center consultation-item__body--short`}
                >
                  <div
                    className={`consultation-item__desc margin-right-20 consultation-item__desc--short`}
                  >
                    <div className="consultation-description__text">
                      {substringDescription}

                      <NavLink
                        to={`${RouteUrls.Budget.projectTasks.preview}/${projectTaskId}`}
                        className="link"
                        target="_blank"
                        title="Szczegóły projektu"
                      >
                        &nbsp;więcej
                      </NavLink>
                    </div>
                  </div>
                  <div className="consultation-item__question">
                    <Form.Row>
                      <Form.Group>
                        <div className="field field--question budget-result">
                          <Form.Control
                            disabled={true}
                            value={`${projectTaskPoints} pkt`}
                            className="field__input field__input--center"
                            aria-label={`Liczba punktów dla projektu ${projectTaskName}`}
                          />
                        </div>
                      </Form.Group>
                    </Form.Row>
                  </div>
                  <div className="consultation-item__image">
                    {projectTaskThumbMainImage && (
                      <figure className="thumbnail">
                        {projectTaskThumbMainImageContentType !==
                          ImageMimeType.SVG && (
                          <div className="svg-container">
                            <img
                              className="thumbnail__content"
                              src={`data:image/jpeg;base64, ${projectTaskThumbMainImage}`}
                              alt={`Główne zdjęcie projektu ${projectTaskName}`}
                            />
                          </div>
                        )}
                        {projectTaskThumbMainImageContentType ===
                          ImageMimeType.SVG && (
                          <div className="svg-container">
                            <SVG
                              src={transformSVG(
                                projectTaskThumbMainImage,
                                `svg-project-${projectTaskId}`,
                                `Główne zdjęcie projektu ${projectTaskName}`
                              )}
                            />
                          </div>
                        )}
                      </figure>
                    )}
                  </div>
                </div>
                <div className="consultation__info text text--font-size-16 text--top-10">
                  <div className="title__label title__label--primary-dark">
                    Kategoria:
                  </div>
                  <div className="title__value">{categoryName}</div>
                </div>
                <div className="consultation-item__header text text--font-size-16 text--weight-700 text--top-10 text--bottom-40">
                  Szacowany koszt:{" "}
                  {projectTaskCost.toLocaleString("pl-PL", {
                    style: "currency",
                    currency: "PLN",
                  })}
                </div>
              </Fragment>
            );
          }
        )}
      </div>
    </Fragment>
  );
};
